module.exports = __webpack_public_path__ + "static/img/banner_img2.790f395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_img2.png
// module id = njWW
// module chunks = 0